import api from '@/lib/api'

export interface FeedbackResult {
  issue_number: number
  issue_url: string
}

export const submitFeedback = (formData: FormData) =>
  api
    .post<{ success: true; data: FeedbackResult }>('/feedback', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(r => r.data.data)
